import { Menu, Transition } from "@headlessui/react"

import { format, startOfToday } from "date-fns"
import { useState } from "react"
import { FiChevronRight } from "react-icons/fi"
import { useNavigate } from "react-router-dom"
import Calendar from "../pages/Profile/Calendar"
import { useQuery } from "react-query"
import { getCurriculumData, getTutionCalendar } from "../API/API"

export default function NavItems({ profileImage }) {
  const navigate = useNavigate()
  const [selectedMonth, setSelectedMonth] = useState(null)
  let today = startOfToday()
  let [selectedDay, setSelectedDay] = useState(today)
  let [currentMonth, setCurrentMonth] = useState(
    format(selectedDay, "MMM-yyyy")
  )
  const [calendarData, setCalendarData] = useState([])
  const [imageLoaded, setImageLoaded] = useState(false)
  const [curriculumData, setCurriculumData] = useState([])

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  // Api Request to fetch Calendar data
  useQuery(["calendar"], () => getTutionCalendar(), {
    onSuccess: data => {
      const formattedData = data.data.data.map(value => ({
        ...value,
        color: getColorAccordingToComponent(value)
      }))
      setCalendarData(formattedData)
    }
  })

  function getCurrentMonth() {
    const date = new Date()
    const month = date.getMonth() + 1
    setSelectedMonth(format(date, "MMMM"))
    return month
  }

  // Api Request to fetch Curriculum data
  useQuery(["curricullum"], () => getCurriculumData(getCurrentMonth()), {
    onSuccess: data => {
      setCurriculumData(data.data.data)
    }
  })

  // This function is used to assign colors on basis of calendarComponent enum
  function getColorAccordingToComponent(value) {
    if (value.calendarComponent === 1) return "#485AFF"
    else if (value.calendarComponent === 2) return "#FFAA06"
    else if (value.calendarComponent === 3) return "#06D79E"
    else if (value.calendarComponent === 4) return "#DA5A5C"
    else if (value.calendarComponent === 5) return "#FFFF00"
    else if (value.calendarComponent === 6) return "#9D4B94"
  }
  return (
    <Menu>
      {props => (
        <>
          <Menu.Button className="h-8 w-8 rounded-full lg:h-11 lg:w-11 ">
            <img
              width={44}
              height={44}
              src={profileImage}
              className={`$ h-8 w-full cursor-pointer rounded-full object-cover lg:h-11 ${
                !imageLoaded ? "hidden" : ""
              }`}
              alt="Profile"
              onLoad={handleImageLoad}
            />
            {!imageLoaded && (
              <div className="h-8 w-full animate-pulse cursor-pointer rounded-full bg-neutral-2 object-cover lg:h-11" />
            )}
          </Menu.Button>
          <Transition
            enter="transition duration-200 ease-in"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-200 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Menu.Items className="shadow-1 profile-popup curriculum-scroll absolute right-0 z-50 rounded-xl bg-white py-7">
              <div className="flex flex-col gap-6 px-6 md:flex-row md:gap-12 md:px-12 ">
                <div className="flex flex-col justify-between gap-4">
                  <div className="h-full min-h-[224px] min-w-[250px]">
                    <Calendar
                      setSelectedDay={setSelectedDay}
                      currentMonth={currentMonth}
                      setCurrentMonth={setCurrentMonth}
                      selectedDay={selectedDay}
                      meetings={calendarData}
                      requireInfoMessage={false}
                    />
                  </div>
                  <div className="flex w-full justify-end">
                    <button
                      className="body-3 rounded-md border border-primary px-2 py-1 text-primary"
                      onClick={() => {
                        props.close()
                        navigate("/my-application-&-account")
                      }}
                    >
                      Your Calendar
                    </button>
                  </div>
                </div>
                {/* Card */}
                <div className="hidden flex-col gap-4 md:flex">
                  <div className="min-w-[250px] rounded-xl bg-[#F5F5F9]">
                    <h2 className="flex items-center justify-center rounded-t-xl bg-secondary-yellow py-4 font-semibold text-white">
                      {selectedMonth}
                    </h2>
                    <div className="px-4">
                      <ol className="curriculum-scroll my-5 h-[224px]">
                        {curriculumData && curriculumData.length > 0 ? (
                          curriculumData.map((item, index) => (
                            <li
                              className="body-3 pb-3 text-neutral-1d "
                              key={index}
                            >
                              <p
                                className={`subtitle-2 ${
                                  item.isCompleted ? "line-through" : ""
                                }`}
                              >
                                {item.curriculumText}
                              </p>
                            </li>
                          ))
                        ) : (
                          <li className="body-3 pb-3 text-neutral-1d ">
                            You have no curriculum for this month.
                          </li>
                        )}
                      </ol>
                    </div>
                  </div>
                  <div className="flex w-full justify-end">
                    <button
                      className="body-3 rounded-md border border-secondary-yellow px-2 py-1 text-secondary-yellow"
                      onClick={() => {
                        props.close()
                        navigate("/curriculum")
                      }}
                    >
                      Your Curriculum
                    </button>
                  </div>
                </div>
              </div>
              <div className="my-5 h-[1px] w-full bg-border-line" />
              <div className="flex w-full justify-center">
                <button
                  className="flex items-center justify-between rounded-xl bg-primary px-4 py-2 text-white md:w-4/12"
                  onClick={() => {
                    props.close()
                    navigate("/my-application-&-account")
                  }}
                >
                  Your Account
                  <FiChevronRight className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  )
}
